// «چه کسانی در برنامه هستند» — بعد از قطعی شدن، برای سازنده و «هستم»ها (WHOSUP-267).
//
// دیتابیس (`plan_roster`، مایگریشن 0155) تصمیم می‌گیرد چه کسی چه ببیند؛ این
// فایل فقط ردیف‌ها را به یک شکلِ واحد برای هر دو اپ برمی‌گرداند. شمارِ مهمان‌ها
// روی هر ردیف تکرار شده (خروجیِ جدولیِ SQL)، این‌جا یک بار برداشته می‌شود.

export interface PlanRosterPerson {
  id: string;
  displayName: string;
  avatarEmoji: string;
  isCreator: boolean;
}

export interface PlanRoster {
  people: PlanRosterPerson[];
  /** «هستم»هایِ بی‌حساب؛ فقط عدد، چون تنها نامشان از دفترچه‌ی سازنده است. */
  guests: number;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export function mapPlanRoster(rows: any[] | null | undefined): PlanRoster {
  const list = rows ?? [];
  return {
    people: list.map((r) => ({
      id: r.user_id,
      displayName: r.display_name ?? '',
      avatarEmoji: r.avatar_emoji ?? '🙂',
      isCreator: !!r.is_creator,
    })),
    guests: list.length ? Number(list[0].guests) || 0 : 0,
  };
}

/** چیزی برای نشان دادن هست؟ فقط خودم در فهرست، فهرست نیست. */
export const rosterWorthShowing = (r: PlanRoster | null | undefined): boolean =>
  !!r && (r.people.length + r.guests) > 1;
